import OccupationStep from "./OccupationStep";

export default OccupationStep;